import { IPublicSession } from 'state/session';
import { State } from 'utils/state';

export function experienceSwitchingSanitation(state: State<IPublicSession>) {
  state.on('beforechange', (keys, arrValues, arrOldValues, sessionChanges) => {
    // When switching to 2D, always clear aveSessionId
    if (keys.includes('activeExperience') && sessionChanges.activeExperience === '2D') {
      state.setValues({ aveSessionId: undefined }, { emit: false });
    }
  });
}
